<sdc-bo-dialog
  headerTitle="Are you sure you want to delete this redis key?"
  [styleClass]="['variant-prominent-title']"
  data-cy="redis-delete-modal">
  <div class="content-wrapper delete-body">
    <sdc-info-grid
      [items]="[{ label: 'Key', value: data?.key }]"
      [columns]="1" />
    <div class="value-block">
      <span class="value-label">Value</span>
      <pre class="pre">{{ json }}</pre>
    </div>
  </div>
  <ng-container sdc-bo-dialog-footer>
    <sdc-button variant="secondary" (onClick)="onDismiss('cancel')">
      Cancel
    </sdc-button>
    <sdc-button variant="destructive" (onClick)="onConfirm(data.key)">
      Permanently delete
    </sdc-button>
  </ng-container>
</sdc-bo-dialog>
